// extracted by mini-css-extract-plugin
export default {"root":"styles-scoped__root--isrWW","primary":"styles-scoped__primary--S3AA4","outlined":"styles-scoped__outlined--HAGXF"};